
import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import SupportTabs from '../components/SupportTabs';

const downloadsData = [
    { id: 1, title: '2025년 제이디윈테크 제품 카탈로그', date: '2025-01-10', writer: '관리자', views: 342, file: 'catalog_2025.pdf' },
    { id: 2, title: '배연창 설치 및 유지보수 가이드', date: '2024-11-20', writer: '기술팀', views: 890, file: 'guide_v2.pdf' },
    { id: 3, title: '환기 시스템 사용 설명서', date: '2024-10-15', writer: '기술팀', views: 560, file: 'manual_vent.pdf' },
    { id: 4, title: '자동폐쇄장치 인증서 사본', date: '2024-08-30', writer: '관리자', views: 210, file: 'cert_closer.jpg' },
    { id: 5, title: '사업자등록증 사본', date: '2024-05-10', writer: '경영지원', views: 150, file: 'biz_license.pdf' },
];

function Downloads() {
    return (
        <div className="text-gray-800">
            {/* Hero Section */}
            <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative z-10 text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white">고객지원</h1>
                    <p className="mt-4 text-white text-lg md:text-xl">
                        고객님의 궁금한 점을 해결해 드립니다.
                    </p>
                </div>
                {/* Support Tabs */}
                <SupportTabs />
            </section>

            {/* Bulletin Board Section */}
            <section className="py-16 px-6 md:px-20 max-w-6xl mx-auto">
                <div className="flex justify-between items-end mb-4 border-b pb-4 border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-800">자료실</h2>
                    <span className="text-sm text-gray-500">총 {downloadsData.length}건</span>
                </div>

                {/* Table / List */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 text-gray-700 border-b border-gray-300">
                                <th className="p-4 w-16 text-center font-semibold">No.</th>
                                <th className="p-4 font-semibold">제목</th>
                                <th className="p-4 w-24 text-center font-semibold">첨부</th>
                                <th className="p-4 w-32 text-center font-semibold">작성자</th>
                                <th className="p-4 w-32 text-center font-semibold">작성일</th>
                                <th className="p-4 w-24 text-center font-semibold">조회수</th>
                            </tr>
                        </thead>
                        <tbody>
                            {downloadsData.map((item, index) => (
                                <motion.tr
                                    key={item.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                    className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                                >
                                    <td className="p-4 text-center text-gray-500">{downloadsData.length - index}</td>
                                    <td className="p-4 font-medium text-gray-800 cursor-pointer hover:underline">{item.title}</td>
                                    <td className="p-4 text-center">
                                        <button className="text-gray-500 hover:text-blue-600 transition-colors" title="다운로드">
                                            <Download size={20} className="mx-auto" />
                                        </button>
                                    </td>
                                    <td className="p-4 text-center text-gray-600">{item.writer}</td>
                                    <td className="p-4 text-center text-gray-500">{item.date}</td>
                                    <td className="p-4 text-center text-gray-500">{item.views}</td>
                                </motion.tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default Downloads;
